//
//
//
//
//
//
//
//
//

export default {
  name: 'AButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
}
